import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { Dialog, Transition } from '@headlessui/react';

import server from '../../../api/server';
import ReactGA from 'react-ga';

import history from "../../../history";
import { setQuickStart, setOnlineStatus, setServerIntents, setAuth, getData, fetchBotData, getBots, updateErrorLogs, updateServerPopup } from '../../../actions';

export class OfflineModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            disabled: false,
            open: true
        };
    }

    modalBackgroundClick = (e) => {
        // console.log("MODAL BACKGROUND CLICK")
        if (e.currentTarget == e.target) {
            this.props.closeModal(true);
        }
    };
    componentDidMount() {
        // console.log("PREMIUM MODAL MOUNTED")
    }

    joinServer = async () => {
        ReactGA.initialize('UA-122665050-1');
        ReactGA.event({
            category: "Server Join",
            label: "Server Modal",
            action: "New Dashboard"
        });
        var response = await server.get("/dashboard/joinserver");
        if (response.data.failed != undefined && response.data.failed == true && response.data.reason == "auth") {
            window.open("https://discord.com/invite/9UPM6S4xyA", '_blank').focus();
        }
        this.setState({ open: false });
        this.props.closeModal();
    };

    start = async () => {
        this.setState({ disabled: true });
        var obj = {
            bot: this.props.bot,
            id: this.props.bot.id
        };

        if (this.props.cocreate == true) {
            obj.cocreate = true;
            var host_user_id = null;
            this.props.bots.forEach(bot => {
                if (bot.id == this.props.bot.id && bot.cocreator == true) {
                    host_user_id = bot.host_user_id;
                }
            });
            obj.host_user_id = host_user_id;
        }
        const response = await server.post("/dashboard/start", obj);
        if (response.data && response.data.response == true) {
            this.props.setOnlineStatus(true);
        } else if (response.data && response.data.response == false && response.data.reason == "logged") {
            this.props.setAuth();
        }
        var quick_start = { ...this.props.quick_start };
        quick_start["on_off"] = true;
        this.props.setQuickStart(quick_start);
        this.setState({ disabled: false, open: false });

        ReactGA.initialize('UA-122665050-1');
        ReactGA.event({
            category: "Offline Modal",
            label: "Online",
            action: "New Dashboard"
        });

        this.props.closeModal();
        return;
    };

    render() {
        return (
            <Transition appear show={this.state.open} as={Fragment}>
                <Dialog
                    as="div"
                    className="relative z-[9999]"
                    onClose={() => {
                        this.setState({ open: false });
                        this.props.closeModal(true);
                    }}
                >
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <div className="fixed inset-0 bg-[#1a1c1f]/90 z-[9999]" />
                    </Transition.Child>

                    <div className="fixed inset-0 overflow-y-auto z-[9999]">
                        <div className="flex min-h-full items-center justify-center p-4 text-center">
                            <Transition.Child
                                as={Fragment}
                                enter="ease-out duration-300"
                                enterFrom="opacity-0 scale-95"
                                enterTo="opacity-100 scale-100"
                                leave="ease-in duration-200"
                                leaveFrom="opacity-100 scale-100"
                                leaveTo="opacity-0 scale-95"
                            >
                                <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-lg bg-[#2f3136] p-6 text-left align-middle shadow-xl transition-all border border-[#1a1c1f]">
                                    <button
                                        onClick={() => {
                                            this.setState({ open: false });
                                            this.props.closeModal(true);
                                        }}
                                        className="absolute right-4 top-4 text-[#b9bbbe] hover:text-white focus:outline-none p-2"
                                    >
                                        <svg
                                            className="h-8 w-8"
                                            fill="none"
                                            viewBox="0 0 24 24"
                                            stroke="currentColor"
                                        >
                                            <path
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                strokeWidth={2.5}
                                                d="M6 18L18 6M6 6l12 12"
                                            />
                                        </svg>
                                    </button>

                                    <div className="flex flex-col items-center space-y-4">
                                        <img
                                            src={process.env.PUBLIC_URL + "/images/logo-red.png"}
                                            alt="BotGhost Logo"
                                            className="w-16 h-16"
                                        />

                                        <h2 className="text-2xl font-bold text-center text-[#ffffff]">
                                            Your Bot is Offline!
                                        </h2>

                                        <p className="text-center text-[#b9bbbe]">
                                            Click the button below or go to settings to turn your bot back online.
                                        </p>

                                        <button
                                            onClick={this.start}
                                            disabled={this.state.disabled}
                                            className="w-full sm:w-auto px-6 py-3 bg-[#ff4444] hover:bg-[#ff6666] text-white font-medium rounded-lg transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-[#ff4444] focus:ring-offset-2 focus:ring-offset-[#2f3136] disabled:opacity-50 disabled:cursor-not-allowed"
                                        >
                                            Go Online
                                        </button>
                                    </div>
                                </Dialog.Panel>
                            </Transition.Child>
                        </div>
                    </div>
                </Dialog>
            </Transition>
        );
    }
}

const mapStateToProps = (state) => ({
    intent: state.data.server_members_intent,
    user: state.data.user,
    premium: state.data.premium,
    page: state.page,
    auth: state.auth,
    data: state.data,
    loading: state.data.loading,
    save_required: state.data.save_required,
    processing: state.data.processing,
    bot: state.data.bot,
    bots: state.data.bots,
    quick_start: state.data.quick_start
});

const mapDispatchToProps = {
    updateServerPopup,
    setOnlineStatus,
    setQuickStart,
    setServerIntents,
    setAuth,
    getData,
    fetchBotData,
    getBots,
    updateErrorLogs
};

export default connect(mapStateToProps, mapDispatchToProps)(OfflineModal);
